import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

// Inizializza Stripe con la chiave pubblica dall'ambiente
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeWrapper = ({ clientSecret, plan, onSuccess, onError }) => {
    const options = {
        clientSecret,
        appearance: {
            theme: 'stripe',
            variables: {
                colorPrimary: '#1976d2',
                colorBackground: '#ffffff',
                colorText: '#30313d',
                colorDanger: '#df1b41',
                fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                spacingUnit: '4px',
                borderRadius: '4px',
            },
        },
        elements: {
            payment: {
                layout: 'tabs'
            }
        },
        loader: 'never',
        locale: 'it'
    };

    if (!clientSecret) {
        return <div>Caricamento...</div>;
    }

    return (
        <Elements stripe={stripePromise} options={options}>
            <CheckoutForm 
                plan={plan}
                onSuccess={onSuccess}
                onError={onError}
            />
        </Elements>
    );
};

export default StripeWrapper; 